import { identity } from "./utils";
export const vars = {
    endpoints: [],
    resource: {
        attributes: [],
    },
    scope: {
        name: "dash0-web-sdk",
        version: __sdkVersion,
        attributes: [],
    },
    signalAttributes: [],
    ignoreUrls: [],
    ignoreErrorMessages: [],
    wrapEventHandlers: true,
    wrapTimers: true,
    propagateTraceHeadersCorsURLs: [],
    maxWaitForResourceTimingsMillis: 10000,
    maxToleranceForResourceTimingsMillis: 50,
    headersToCapture: [],
    urlAttributeScrubber: identity,
    pageViewInstrumentation: {
        trackVirtualPageViews: true,
        includeParts: [],
    },
    enableTransportCompression: false,
};
